import { CreateCommentBox } from '../create-comment-box';
import { ActionTypes, IContent } from '../utils/types';
export const EditComment = ({
  content,
  setCommentContent,
  commentId,
  setDisplayActionModal,
}: {
  content: IContent;
  setCommentContent: (value: IContent) => void;
  commentId: number;
  setDisplayActionModal: (value: boolean) => void;
}) => {
  return (
    <div className="p-9" data-testid="edit-comment">
      <h5 className=" mb-6 text-s-20">Edit your comment</h5>
      <CreateCommentBox
        type={ActionTypes.EditComment}
        content={content}
        setCommentContent={setCommentContent}
        commentId={commentId}
        setDisplayActionModal={setDisplayActionModal}
      />
    </div>
  );
};
